export default "__VITE_PUBLIC_ASSET__d7637e2d__"